module.exports = __webpack_public_path__ + "img/home.7eeb7173.png";